export { default } from './View';



// WEBPACK FOOTER //
// ./src/components/View/index.js